var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTranslate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.75 1.98266H4.7175M4.7175 1.98266H7.3625M4.7175 1.98266V0.75M9.56667 1.98266H7.3625M7.3625 1.98266C6.89816 3.66641 5.92244 5.25934 4.81154 6.65874L6.51169 8.44967M1.97846 9.68233C2.99489 8.74692 3.94182 7.73681 4.81154 6.66023C4.24581 5.98583 3.45231 4.89758 3.22454 4.40481M9.15278 17.25L10.3768 14.2726M10.3768 14.2726L12.8264 8.31767L15.276 14.2726M10.3768 14.2726H15.276M16.5 17.25L15.276 14.2726",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 11.9531C3.75 12.8745 3.75 13.3358 3.97116 13.6666C4.06694 13.81 4.19003 13.9331 4.33341 14.0288C4.66416 14.25 5.1255 14.25 6.04688 14.25M14.25 6.04688C14.25 5.1255 14.25 4.66416 14.0288 4.33341C13.9331 4.19003 13.81 4.06694 13.6666 3.97116C13.3358 3.75 12.8745 3.75 11.9531 3.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTranslate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/translate.7737487c.svg";
export { ForwardRef as ReactComponent };